<div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success',
            'alert-danger': message.type === 'error' }" style="text-align: center;cursor: pointer;">
            <a class="close" (click)="removeAlert()" style="cursor: pointer;">&times;</a>
    {{message.text}}
</div>